module.exports = __webpack_public_path__ + "static/media/burgerMenuIcon.abda6e24.svg";